import { InteractionRequiredAuthError, } from '@azure/msal-browser';
import { getUrlParam, includeCorsProxy } from '../store/helpers';
class BusinessCentralService {
    msalInstance;
    baseUrl;
    constructor(msalInstance) {
        this.msalInstance = msalInstance ?? null;
        this.baseUrl = 'https://api.businesscentral.dynamics.com/v2.0';
    }
    async getAccessToken() {
        const crane = getUrlParam('crane') ?? false;
        if (crane || !this.msalInstance) {
            return '';
        }
        const account = this.msalInstance.getActiveAccount() ?? undefined;
        const tokenRequest = {
            scopes: ['https://api.businesscentral.dynamics.com/.default'],
            account,
        };
        let response;
        try {
            response = await this.msalInstance.acquireTokenSilent(tokenRequest);
        }
        catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                await this.msalInstance.acquireTokenRedirect(tokenRequest);
            }
            throw error;
        }
        const customWindow = window;
        customWindow.loginConfig = customWindow.loginConfig ?? {};
        customWindow.loginConfig.cloudConfig =
            customWindow.loginConfig.cloudConfig ?? {};
        customWindow.loginConfig.cloudConfig.oAuthToken =
            response.accessToken || '';
        return response.accessToken;
    }
    async getEnvironments() {
        try {
            const token = await this.getAccessToken();
            const response = await fetch(`https://api.businesscentral.dynamics.com/environments/v1.1`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data.value;
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error fetching environments:', error);
            throw error;
        }
    }
    async getCompanies(tenantId, environmentName) {
        try {
            const token = await this.getAccessToken();
            const response = await fetch(`${this.baseUrl}/${tenantId}/${environmentName}/api/v2.0/companies`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data.value;
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error fetching companies:', error);
            throw error;
        }
    }
    async getPosUnits(tenantId, environment, company, options) {
        try {
            const encodedCompany = options?.isOnPremise
                ? decodeURIComponent(company)
                : encodeURIComponent(company);
            const rawUrl = `https://api.npretail.app/${tenantId}/${environment}/${encodedCompany}/pos/unit?pageSize=50`;
            const url = options?.isOnPremise ? includeCorsProxy(rawUrl) : rawUrl;
            const headers = {
                'Content-Type': 'application/json',
            };
            if (options?.isOnPremise) {
                if (!options.basicAuthToken) {
                    throw new Error('Missing basicAuthToken for onPremise request');
                }
                headers['Authorization'] = `Basic ${options.basicAuthToken}`;
                headers['x-npr-api-remote-type'] = 'crane';
            }
            else {
                const token = await this.getAccessToken();
                headers['Authorization'] = `Bearer ${token}`;
            }
            const response = await fetch(url, { headers });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            return json.data;
        }
        catch (error) {
            console.error(`Error fetching POS Units:`, error);
            throw error;
        }
    }
}
export default BusinessCentralService;
